interface AppConfig {
  apiUrl: string;
  googleClientId: string;
  githubClientId: string;
  stripePublishableKey: string;
}

let _config: AppConfig | null = null;

const DEV_DEFAULTS: AppConfig = {
  apiUrl: process.env.REACT_APP_API_URL || '',
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  githubClientId: process.env.REACT_APP_GITHUB_CLIENT_ID || '',
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',
};

export async function loadConfig(): Promise<AppConfig> {
  if (_config) return _config;

  if (process.env.NODE_ENV === 'development') {
    _config = DEV_DEFAULTS;
    return _config;
  }

  try {
    const res = await fetch('/config.json');
    if (!res.ok) throw new Error(`config.json: ${res.status}`);
    _config = await res.json();
  } catch (err) {
    console.error('Failed to load /config.json, falling back to defaults:', err);
    _config = DEV_DEFAULTS;
  }
  return _config!;
}

export function getConfig(): AppConfig {
  if (!_config) throw new Error('Config not loaded yet — call loadConfig() before React mount');
  return _config;
}
